import React from 'react';
import { useParams } from 'react-router-dom';
import { MainLayout } from '../components';
import OrganizationProfileForm from '../components/OrganizationProfileForm';
import styles from './EditOrganizationPage.module.css';

const EditOrganizationPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const organizationId = id ? parseInt(id) : undefined;

  return (
    <MainLayout>
      <div className={styles.container}>
        <h1 className={styles.title}>Modifier le profil de l'organisation</h1>
        <p className={styles.subtitle}>
          Mettez à jour les informations de votre organisation pour les maintenir à jour.
        </p>
        
        <div className={styles.formWrapper}>
          {organizationId ? (
            <OrganizationProfileForm 
              organizationId={organizationId} 
              isEditing={true} 
            />
          ) : (
            <p className={styles.errorText}>
              Identifiant d'organisation non valide. Veuillez réessayer.
            </p>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default EditOrganizationPage;
